<div class="top-controls" *ngIf="branchIds.length > 0">
    <div class="top-bar">
        <div class="left">
            <single-choice
                [topic]="'multi-action'"
                [ticketId]="1"
                [editMode]="true"
                [completedUrl]="actionUrlObserver"
                [choiceObserver]="actionIdObserver"
                [icon]="'low_priority'"
                (choiceEvent)="relaySingleChoice($event)"
                [labelOnDemand]="actionLabelerByService"
                ></single-choice>
        </div>
        <div class="right">
            <button class="plus" (click)="createTicket()">
                <i class="fa fa-plus" aria-hidden="true"></i>
            </button>
        </div>
    </div>
</div>

<div class="accordion-container">
    <p-accordion [activeIndex]="activeBranchIndex" (onOpen)="onTabOpen($event)" (onClose)="onTabClose()">
        <p-accordionTab
            *ngFor="let branchId of branchIds; let i = index"
            [header]="branchName(branchId) + ' (' + branchTicketCount(branchId) + ')'"
            >
            <div class="table-container" *ngIf="getTickets(branchId).length > 0">
                <table>
                    <tbody>
                    <ticket-row
                        *ngFor="let ticket of getTickets(branchId)"
                        [ticket]="ticket"
                        [isSelectedFlag]="isSelected(ticket)"
                        [selectedTicket]="selectedTicket"
                        (selectToggled)="toggleSelect($event)"
                        (ticketClicked)="select($event)"
                        ></ticket-row>
                    </tbody>
                </table>
                <div class="pagination-info">
                    <div class="pagination-controls" *ngIf="getTotalPages(branchId) > 1">
                        <button
                            *ngFor="let page of getPaginationButtons(branchId)"
                            [disabled]="page === getCurrentPage(branchId)"
                            (click)="page !== '...' && goToPage(branchId, +page)"
                            >
                            {{ page === "..." ? "..." : +page + 1 }}
                        </button>
                    </div>
                    <span class="row-count">
                        {{ getStartRow(branchId) + 1 }}–{{ getEndRow(branchId) }} {{ 'pagination.of' | translate }} {{ branchTicketCount(branchId) }}
                    </span>
                </div>
            </div>

            <div *ngIf="getTickets(branchId).length === 0" class="ticket-empty">
                <div class="icon-empty">
                    <span class="material-icons-outlined">confirmation_number</span>
                </div>
            </div>
        </p-accordionTab>
    </p-accordion>
</div>

<div *ngIf="branchIds.length === 0" class="ticket-empty">
    <div class="icon-empty">
        <span class="material-icons-outlined">confirmation_number</span>
    </div>
</div>
